import { useState } from 'react';

import { PassportGroupHeader } from './PassportGroupHeader';
import { PassportGroupPassportsTable } from './PassportGroupPassportsTable';
import styles from './PassportGroup.module.scss';

interface IPassportGroupProps {
  backUrl: string;
  onMassCancellationApply?: () => void;
  onMassCancellationOfKnoApply?: () => void;
  onMassCancellationByKnoApply?: (passportIds: number[]) => void;
  onMassDeletionApply?: () => void;
  isShowCheckbox: boolean;
}

export const PassportGroup = ({
  backUrl,
  onMassCancellationApply,
  onMassCancellationOfKnoApply,
  onMassCancellationByKnoApply,
  onMassDeletionApply,
  isShowCheckbox,
}: IPassportGroupProps) => {
  const [checkedItems, setCheckedItems] = useState<{ [p: number]: boolean }>({});

  return (
    <div className={styles.Content}>
      <PassportGroupHeader
        backUrl={backUrl}
        checkedItems={checkedItems}
        resetCheckedItems={() => setCheckedItems({})}
        onMassCancellationApply={onMassCancellationApply}
        onMassCancellationOfKnoApply={onMassCancellationOfKnoApply}
        onMassCancellationByKnoApply={onMassCancellationByKnoApply}
        onMassDeletionApply={onMassDeletionApply}
      />
      <PassportGroupPassportsTable
        checkedItems={checkedItems}
        setCheckedItems={setCheckedItems}
        isShowCheckbox={isShowCheckbox}
      />
    </div>
  );
};
